
import React from "react";
import { usePlot } from "@/hooks/usePlot";
import { PlotDetails } from "@/components/plot/PlotDetails";
import { PlotHouses } from "@/components/plot/PlotHouses";
import { PlotExpenses } from "@/components/plot/PlotExpenses";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ScrollArea } from "@/components/ui/scroll-area";

const Plot = () => {
  const { plot, isLoading } = usePlot();
  
  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-6 md:py-8">
        <div className="flex items-center justify-center min-h-[50vh]">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }
  
  if (!plot) {
    return (
      <div className="container mx-auto px-4 py-6 md:py-8">
        <div className="flex flex-col mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Mi parcela</h1>
          <p className="text-muted-foreground mt-1">Información sobre su parcela</p>
        </div>
        
        <Alert variant="destructive" className="mt-6">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Sin parcela</AlertTitle>
          <AlertDescription>
            Su casa no pertenece a ninguna parcela.
          </AlertDescription>
        </Alert>
      </div>
    );
  }
  
  return (
    <div className="container mx-auto px-4 py-6 md:py-8">
      <div className="flex flex-col mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800">Mi parcela</h1>
        <p className="text-muted-foreground mt-1">Información sobre su parcela</p>
      </div>
      
      <ScrollArea className="h-[calc(100vh-10rem)]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-full pb-6">
          <PlotDetails name={plot.name} description={plot.description} />
          <PlotHouses plotId={plot.id} />
          <div className="md:col-span-2">
            <PlotExpenses plotId={plot.id} />
          </div>
        </div>
      </ScrollArea>
    </div>
  );
};

export default Plot;
